import { render, staticRenderFns } from "./bookPost.vue?vue&type=template&id=2ba21f13&"
import script from "./bookPost.vue?vue&type=script&lang=js&"
export * from "./bookPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports